export default __webpack_public_path__ + "static/The Home_Image 4_carousel 1@2x-9836dae5918750b0303e1cd9b647eb0a.jpg";